export default {
  qInfo: { qType: 'dataTeams' },
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['TeamID'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['FIFA Name'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Group'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Elo_Rank'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['FIFA_Rank'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Won'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Lost'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Drawn'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Unweighted Goal Scored'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Unweighted Goal Received'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Elo_TournamentRank'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['FIFA_TournamentRank'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['WC'],
          qSortCriterias: [
            {
              qSortByAscii: -1,
            },
          ],
        },
        qNullSuppression: false,
      },
    ],
    qInitialDataFetch: [{
      qWidth: 20,
      qHeight: 500,
    }],
  },
};
